import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent, GetEmailTrackingParams } from './types';

interface NewsOpenProperties {
  source: PosthogTrackingSource;
  entities?: string[];
}

interface NewsDrawerOpenProperties {
  source: PosthogTrackingSource;
  newsId: string;
  entities?: string[];
}

interface NewsFilterProperties {
  source: PosthogTrackingSource;
  type: 'most_read' | 'watchlist';
  entities?: string[];
}

export const createNewsEvents = (
  captureTrackingEvent: CaptureTrackingEvent,
  getEmailTrackingParams?: GetEmailTrackingParams
) => {
  const trackNewsOpen = ({ source, entities }: NewsOpenProperties) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.NEWS_OPEN,
      properties: {
        source,
        ...(entities !== undefined && { entities }),
      },
    });

  const trackNewsDrawerOpen = ({
    source,
    newsId,
    entities,
  }: NewsDrawerOpenProperties) => {
    const emailParams = getEmailTrackingParams?.();
    const finalSource = emailParams?.source ?? source;

    return captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.NEWS_DRAWER_OPEN,
      properties: {
        source: finalSource,
        newsId,
        ...(entities !== undefined && { entities }),
        ...(emailParams && { utm_campaign: emailParams.utm_campaign }),
      },
    });
  };

  const trackNewsFilter = ({ source, type, entities }: NewsFilterProperties) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.NEWS_FILTER_SELECTED,
      properties: {
        source,
        type,
        ...(entities !== undefined && { entities }),
      },
    });

  return { trackNewsOpen, trackNewsDrawerOpen, trackNewsFilter };
};
